import TimeManager from './time_manager';
const { ccclass, property } = cc._decorator;

@ccclass
export default class invitationCountdownManager{
    public static readonly instance:invitationCountdownManager　= new invitationCountdownManager();
    private countdown: number = 0;
    private timeID:number;
    resetTime() {
        this.cancleCounting();
        this.countdown = 0;
    }
    getCountdown() {
        return this.countdown;
    }
    startCounting() {
        if (this.timeID == null)
        {
            this.timeID = TimeManager.instance.doSchedule(this.update.bind(this), 0, cc.macro.REPEAT_FOREVER);
        }
    }
    cancleCounting()
    {
        if (this.timeID) {
            TimeManager.instance.cancelSchedule(this.timeID);
            this.timeID = null;
        }
    }
    update() {
        this.countdown += cc.director.getDeltaTime();
        // var delta = TimeManager.instance._showTime - TimeManager.instance._hideTime
        if(Math.floor(this.countdown)>59)
        {
            this.cancleCounting();
        }
    }
    setInterval(interval:number)
    {
        if(this.countdown>0)
        {
            this.countdown+=interval;
            if(Math.floor(this.countdown)>59)
            {
                this.cancleCounting();
            }
        }
    }
}
